import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import DataSourceProps from './DataSourceProps'

import Filter from './Filter'
import Group from './Group'
import Schema from './Schema'
import Sort from './Sort'
import Transport from './Transport'

export default {
    template: '<div></div>',
    props: DataSourceProps,
    mixins: [
        KendoBaseComponent,
        Filter,
        Group,
        Schema,
        Sort,
        Transport
    ],
    mounted () {
        this.$watch(vm => [vm.filter, vm.filterValue, vm.filterField,
            vm.filterFilters, vm.filterLogic, vm.filterOperator].join(), () => {
            this.kendoDataSource.filter(this.widgetOptions.filter)
        },{ deep: true })

        this.$watch(vm => [vm.group, vm.groupField, vm.groupDir, vm.groupAggregates].join(), () => {
            this.kendoDataSource.group(this.widgetOptions.group)
        },{ deep: true })

        this.$watch(vm => [vm.aggregate, vm.aggregateAggregate, vm.aggregateField].join(), () => {
            this.kendoDataSource.aggregate(this.widgetOptions.aggregate)
        },{ deep: true })

        this.$watch(vm => [vm.sort, vm.sortDir, vm.sortField, vm.sortCompare].join(), () => {
            this.kendoDataSource.sort(this.widgetOptions.sort)
        },{ deep: true })

        this.$watch(vm => [vm.page].join(), () => {
            this.kendoDataSource.page(this.widgetOptions.page)
        },{ deep: true })

        this.$watch(vm => [vm.pageSize].join(), () => {
            this.kendoDataSource.pageSize(this.widgetOptions.pageSize)
        },{ deep: true })

        this.$watch(vm => [vm.data].join(), () => {
            this.kendoDataSource.data(this.widgetOptions.data)
        },{ deep: true })
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/KendoDataSourceBaseMixin.js